/* Mobile-only progressive enhancement; the server-rendered menu remains the fallback. */
(() => {
  const media = window.matchMedia('(max-width: 749px)');
  const initialize = () => {
    const panel = document.querySelector('header-drawer #link-parts-perlengkapan');
    if (!panel || panel.dataset.vdrPartsReady) return;
    panel.dataset.vdrPartsReady = 'true';
    const drawer = panel.closest('header-drawer');
    const outer = drawer.querySelector(':scope > details');
    const details = panel.parentElement;
    const list = panel.querySelector('.menu-drawer__inner-submenu > ul');
    const back = panel.querySelector('.menu-drawer__back-button');
    const backText = back.querySelector('.menu-drawer__menu-item-text');
    const originalTitle = backText.textContent;
    const originalBackLabel = back.getAttribute('aria-label');
    const originalBackAction = back.getAttribute('on:click');
    const rootSummary = details.querySelector(':scope > summary');
    const menuSummary = outer.querySelector(':scope > summary');
    const rows = Array.from(list.children);
    const groups = [];
    let selected = null;
    let enabled = false;
    let focusTimer;
    const style = document.createElement('style');
    style.textContent = `@media(max-width:749px){
      #link-parts-perlengkapan[data-vdr-parts-active] [hidden]{display:none!important}
      #link-parts-perlengkapan[data-vdr-parts-active] .vdr-parts-choice{width:100%;text-align:left;background:none;border:0;color:inherit;font:inherit;cursor:pointer}
      #link-parts-perlengkapan[data-vdr-parts-active] :is(a,button){min-height:44px}
      #link-parts-perlengkapan[data-vdr-parts-active] .menu-drawer__close-button{min-width:44px}
      #link-parts-perlengkapan[data-vdr-parts-active] .vdr-parts-all{text-transform:none}
      #link-parts-perlengkapan[data-vdr-parts-active] :focus-visible{outline:2px solid currentColor;outline-offset:-2px}
    }`;
    drawer.append(style);
    rows.forEach((row) => {
      const link = row.querySelector(':scope > a');
      const children = row.querySelector(':scope > ul');
      if (!link || !children) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vdr-parts-choice menu-drawer__menu-item menu-drawer__menu-item--parent focus-inset';
      const label = link.querySelector('.menu-drawer__menu-item-text');
      button.append(label.cloneNode(true));
      button.append(rootSummary.querySelector('.icon-caret').cloneNode(true));
      button.setAttribute('aria-expanded', 'false');
      const childId = children.id;
      if (!childId) children.id = `${link.id}-children`;
      button.setAttribute('aria-controls', children.id);
      const prefix = document.createElement('span');
      prefix.textContent = 'Lihat semua ';
      const group = {row, link, children, button, label, prefix, childId};
      button.addEventListener('click', () => show(group, true));
      groups.push(group);
    });
    function show(group, focus) {
      const previous = selected;
      selected = group;
      // Native on:click is document-capture delegated; suppress it before a group Back click.
      if (group) back.removeAttribute('on:click');
      else back.setAttribute('on:click', originalBackAction);
      rows.forEach(row => { row.hidden = !!group && row !== group.row; });
      groups.forEach(item => {
        const active = item === group;
        item.button.hidden = active;
        item.button.setAttribute('aria-expanded', String(active));
        item.link.hidden = !active;
        item.children.hidden = !active;
      });
      backText.textContent = group ? group.label.textContent.replace(/^Lihat semua /, '') : originalTitle;
      back.setAttribute('aria-label', group ? `Kembali ke ${originalTitle.trim()}` : originalBackLabel);
      panel.querySelector('.menu-drawer__inner-submenu').scrollTop = 0;
      if (focus) (group ? back : previous?.button || back).focus();
    }
    function configure() {
      if (media.matches === enabled) return;
      enabled = media.matches;
      if (enabled) {
        panel.setAttribute('data-vdr-parts-active', '');
        groups.forEach(item => {
          item.row.insertBefore(item.button, item.link);
          item.label.prepend(item.prefix);
          item.link.classList.add('vdr-parts-all');
        });
        show(null, false);
      } else {
        selected = null;
        panel.removeAttribute('data-vdr-parts-active');
        rows.forEach(row => { row.hidden = false; });
        groups.forEach(item => {
          item.button.remove(); item.prefix.remove();
          item.link.hidden = false; item.children.hidden = false;
          item.link.classList.remove('vdr-parts-all');
        });
        backText.textContent = originalTitle;
        back.setAttribute('on:click', originalBackAction);
        back.setAttribute('aria-label', originalBackLabel);
      }
    }
    back.addEventListener('click', event => {
      if (!enabled) return;
      if (selected) {
        event.preventDefault(); event.stopImmediatePropagation(); show(null, true);
      } else {
        clearTimeout(focusTimer);
        focusTimer = setTimeout(() => rootSummary.focus(), 450);
      }
    }, true);
    window.addEventListener('keydown', event => {
      if (!enabled || !details.open || !panel.contains(event.target)) return;
      // Run before the native document-capture trap, whose list includes hidden groups.
      if (event.key === 'Tab') event.stopImmediatePropagation();
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopImmediatePropagation();
        if (selected) show(null, true);
        else back.click();
      }
      if (event.key === 'Tab') {
        const items = Array.from(panel.querySelectorAll('a[href],button:not(:disabled)')).filter(el => !el.closest('[hidden]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }, true);
    // The native drawer also listens to keyup; do not close an extra level.
    panel.addEventListener('keyup', event => {
      if (enabled && event.key === 'Escape') event.stopImmediatePropagation();
    }, true);
    panel.querySelector('.menu-drawer__close-button').addEventListener('click', () => {
      if (!enabled) return;
      show(null, false);
      clearTimeout(focusTimer);
      focusTimer = setTimeout(() => menuSummary.focus(), 450);
    });
    details.addEventListener('toggle', () => {
      if (!enabled) return;
      show(null, false);
      if (details.open) {
        clearTimeout(focusTimer);
        focusTimer = setTimeout(() => { if (details.open && enabled) back.focus(); }, 450);
      }
    });
    outer.addEventListener('toggle', () => {
      if (enabled && !outer.open) show(null, false);
    });
    media.addEventListener('change', configure);
    configure();
  };
  const start = () => {
    const section = document.querySelector('header-drawer')?.closest('.shopify-section');
    // Horizon hydrates the header after DOMContentLoaded and replaces its children.
    // Enhance the final DOM, not the soon-to-be-replaced server nodes.
    if (!section || section.dataset.hydrated === 'true') { initialize(); return; }
    const observer = new MutationObserver(() => {
      if (section.dataset.hydrated === 'true') { observer.disconnect(); initialize(); }
    });
    observer.observe(section, {attributes:true, attributeFilter:['data-hydrated']});
    window.addEventListener('load', () => {
      setTimeout(() => {
        if (!section.querySelector('[data-vdr-parts-ready]')) initialize();
      }, 10000);
    }, {once:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', start);
})();
